import { render, staticRenderFns } from "./GanttHeaderItem.vue?vue&type=template&id=7848332e&scoped=true&lang=pug&"
import script from "./GanttHeaderItem.vue?vue&type=script&lang=js&"
export * from "./GanttHeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./GanttHeaderItem.vue?vue&type=style&index=0&id=7848332e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7848332e",
  null
  
)

export default component.exports